export default {
    Proxy: {
        Title: "Danh sách proxy",
        SearchEmptyText: "Tìm theo tên, cấu hình, quốc gia",
        Name: "Tên",
        Config: "Cấu hình",
        Inactive: "Dừng sử dụng",
        ListInactive: "Tình trạng",
        Created: "Ngày tạo",
        IP: "IP",
        Port: "Cổng",
        ProxyType: "Loại Proxy",
        Server: "server",
        Status: "Được phép sử dụng",
        ip: "Ip",
        port: "Cổng",
        proxy_type: "Loại proxy",
        username: "Tài khoản",
        password: "Mật khẩu",
        Country: "Quốc gia",
        City: "Thành phố"
    },
    ProxyLog: {
        Title: "Lịch sử sử dụng proxy",
        SearchEmptyText: "Tìm theo mục tiêu",
        created: "Ngày sử dụng",
        proxy: "Proxy",
        note: "Mục đích",
        target: "Mục tiêu",
        released: "Ngày dùng xong",
        expires: "Ngày hết hạn",
        duration: "Thời gian sử dụng (ms)",
        release_reason: 'Lý do giải phóng',
    },
    ProxyReleaseReason:{
        released: "Sử dụng xong",
        reclaimed: "Hết hạn",
        reported: "Chết giữa chừng",
        null: "",
    }
};  
